export default function nextElementFocus(event:any) {
  event.srcElement.nextElementSibling.focus()
}